import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useDetailHandler from '../../hooks/useDetailHandler';
import { onActionKey } from '../../utils';
import { manualCashLimitType } from '../../types';
import './_styles_/ManualCashLimitRow.css';
import ManualCashLimitDetailTab from './ManualCashLimitDetailTab';
import Number from '../Number';
import DateTime, { LONG_DATE } from '../DateTime';

ManualCashLimitRow.propTypes = {
    manualCashLimit: manualCashLimitType.isRequired,
};

function ManualCashLimitRow(props) {
    const {
        manualCashLimit,
    } = props;
    const { isDetailVisible, toggleDetail, onDetailDelete } = useDetailHandler(manualCashLimit.id);
    return (
        <>
            <div className="rich-list-row manual-cash-limit-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="manual-cash-limit-header--values--member">{manualCashLimit.member.memberId}</div>
                <div className="manual-cash-limit-header--values--limit-value"><Number value={manualCashLimit.limitValue} fractionDigits={2} /></div>
                <div className="manual-cash-limit-header--values--begin-date"><DateTime value={manualCashLimit.beginDate} format={LONG_DATE} /></div>
                <div className="manual-cash-limit-header--values--end-date"><DateTime value={manualCashLimit.endDate} format={LONG_DATE} /></div>
                <div className="manual-cash-limit-header--values--currency">{manualCashLimit.currency.code}</div>
                <div className="manual-cash-limit-header--values--clearing-house">{manualCashLimit.clearingHouse.code}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && (
                <ManualCashLimitDetailTab
                    manualCashLimit={manualCashLimit}
                    onDetailDelete={onDetailDelete}
                />
            )}
        </>
    );
}

export default ManualCashLimitRow;
